import { inject, Injectable } from '@angular/core'
import { HttpClient } from '@angular/common/http'
import { environment } from '@env'
import { PermissionMap } from '@features/permissions/permission.models'
import { Observable } from 'rxjs'

@Injectable({ providedIn: 'root' })
export class PermissionsApi {
  readonly #http: HttpClient = inject(HttpClient)

  fetchPermissions(): Observable<PermissionMap> {
    return this.#http.get<PermissionMap>(environment.API.PERMISSION_CONFIG)
  }
}
